const apiUrl = process.env.REACT_APP_API_URL;
export const GetUsuarisPractica = async (practicaId : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/practica/${practicaId}/users`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
